<template>
  <div class="md-layout">
    <div id="objectHeaderContentHidden" style="display: none;">
      <div><md-icon class="icon-color">{{list.pageIcon}}</md-icon></div>
      <div>
        <h1 class="md-title icon-color">{{ $route.name }} </h1>
        <h2 style="visibility: hidden;opacity:0;"></h2>
      </div>
    </div>

    <div class="md-layout-item">
      <ElasticList :list="list"></ElasticList>
    </div>
  </div>
</template>

<script>
  import ElasticList from "@/components/DynamicForm/ElasticList";

  export default {
    components: {
      ElasticList
    },
    data() {
      return {
        list: {
          hideListHeader: true,
          editPath: "companies",
          pageTitle: "Companies",
          pageIcon: "store",
          listQueryId: "searchCompanyCustoms",
          responseFieldName: "searchCompanys",
          deleteQueryId: "deleteCompany",
          linkRows: true,
          deleteRelatedRecord: {
            record: [
              { deleteSyncQueryId: "deletePersonCompany", relatedModelItem: 'persons'},
              { deleteSyncQueryId: "deleteCaseCompany", relatedModelItem: 'cases'},
            ]
          },
          columns: {
            name: { label: "Name", sortable: true },
            createdAt: { label: "Created", sortable: true},
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          fuseSearch: null,
        },
      };
    },    
  };
</script>

<style></style>
